export default () => ({
  loading: false,
  errors: {},
  title: '',
  entity: '',
  entities: '',
  prefixRouter: '',
  currentEntity: {}
})



// WEBPACK FOOTER //
// ./src/crud/resources/data.js